import { TaskCompletionItem } from '@/apis/business/agent/performance/types';

export type CallJourneyStageKey = 'dialed' | 'connected' | 'answered' | 'successful';

export type CallJourneyStage = {
  key: CallJourneyStageKey;
  label: string;
  value: number;
  color?: string;
};

export type OutboundOverview = {
  total_call_duration: number;
  working_days: number;
  average_duration: number;
  avg_answered_rate: number;
  calls_dialed: number;
  dnc_blocked: number;
  calls_answered: number;
  answered_human: number;
  answered_voicemail: number;
  calls_successful: number;
  transferred_to_staff: number;
};

export type PickupRateByHourItem = {
  time: string;
  value: number;
};

export type OutboundPerformanceResponse = {
  overview: OutboundOverview;
  call_journey: CallJourneyStage[];
  pickup_rate_by_hour: PickupRateByHourItem[];
  tasks_completion: TaskCompletionItem[];
};

export const EMPTY_CALL_JOURNEY: CallJourneyStage[] = [
  { key: 'dialed', label: 'Dialed', value: 0 },
  { key: 'connected', label: 'Connected', value: 0 },
  { key: 'answered', label: 'Answered', value: 0 },
  { key: 'successful', label: 'Successful', value: 0 }
];

/** Map performance API payload into the outbound dashboard shape (zeros when fields missing). */
export function mapOutboundPerformance(data: any): OutboundPerformanceResponse {
  const overview = data?.overview ?? {};

  const callJourney: CallJourneyStage[] = Array.isArray(data?.call_journey)
    ? EMPTY_CALL_JOURNEY.map((stage) => {
        const match = data.call_journey.find(
          (item: any) => item?.key === stage.key || item?.label?.toLowerCase() === stage.label.toLowerCase()
        );
        return { ...stage, value: Number(match?.value ?? 0) };
      })
    : EMPTY_CALL_JOURNEY;

  return {
    overview: {
      total_call_duration: Number(overview.total_call_duration ?? 0),
      working_days: Number(overview.working_days ?? 0),
      average_duration: Number(overview.average_duration ?? 0),
      avg_answered_rate: Number(overview.avg_answered_rate ?? 0),
      calls_dialed: Number(overview.calls_dialed ?? overview.calls_made ?? 0),
      dnc_blocked: Number(overview.dnc_blocked ?? 0),
      calls_answered: Number(
        overview.calls_answered ?? overview.contacts_reached ?? overview.total_answered_calls ?? 0
      ),
      answered_human: Number(overview.answered_human ?? 0),
      answered_voicemail: Number(overview.answered_voicemail ?? 0),
      calls_successful: Number(overview.calls_successful ?? overview.conversions ?? 0),
      transferred_to_staff: Number(overview.transferred_to_staff ?? overview.transferred_calls ?? 0)
    },
    call_journey: callJourney,
    pickup_rate_by_hour: Array.isArray(data?.pickup_rate_by_hour)
      ? data.pickup_rate_by_hour
      : Array.isArray(data?.daily_performance)
        ? data.daily_performance
        : [],
    tasks_completion: Array.isArray(data?.tasks_completion) ? data.tasks_completion : []
  };
}
